package com.sddamico.draftmachine.pages.draft

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.sddamico.draftmachine.api.ApiException
import com.sddamico.draftmachine.api.apiGet
import com.sddamico.draftmachine.components.layouts.LoadingFrame
import com.sddamico.draftmachine.components.layouts.MobileFrame
import com.sddamico.draftmachine.ds.feedback.toastMotion
import com.sddamico.draftmachine.ds.motion.ChangeCue
import com.sddamico.draftmachine.ds.motion.Motion
import com.sddamico.draftmachine.ds.motion.Presence
import com.sddamico.draftmachine.ds.motion.TransitionRole
import com.sddamico.draftmachine.ds.motion.ViewTransitions
import com.sddamico.draftmachine.ds.motion.changeCue
import com.sddamico.draftmachine.ds.motion.transitionRole
import com.sddamico.draftmachine.ds.overlays.PanelDialog
import com.sddamico.draftmachine.pages.pools.playerTeamLabel
import com.sddamico.draftmachine.components.pwa.PushNotificationBanner
import com.sddamico.draftmachine.components.sections.AppHeader
import com.sddamico.draftmachine.components.widgets.PickOriginStamp
import com.sddamico.draftmachine.components.widgets.StatusBadge
import com.sddamico.draftmachine.data.DraftStatus
import com.sddamico.draftmachine.data.Sport
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmEffects
import com.sddamico.draftmachine.ds.DmType
import com.sddamico.draftmachine.ds.Icon
import com.sddamico.draftmachine.ds.IconWeight
import com.sddamico.draftmachine.ds.PressableStyle
import com.sddamico.draftmachine.ds.backgroundImageRaw
import com.sddamico.draftmachine.ds.brand.Logo
import com.sddamico.draftmachine.ds.brand.LogoVariant
import com.sddamico.draftmachine.ds.core.Avatar
import com.sddamico.draftmachine.ds.core.AvatarSize
import com.sddamico.draftmachine.ds.core.Badge
import com.sddamico.draftmachine.ds.core.BadgeTone
import com.sddamico.draftmachine.ds.displayBlock
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.displayGrid
import com.sddamico.draftmachine.ds.displayInlineFlex
import com.sddamico.draftmachine.ds.dmGridBackdrop
import com.sddamico.draftmachine.ds.dmPanel
import com.sddamico.draftmachine.ds.dmStamp
import com.sddamico.draftmachine.ds.feedback.Gauge
import com.sddamico.draftmachine.ds.feedback.GaugeTone
import com.sddamico.draftmachine.ds.feedback.Toast
import com.sddamico.draftmachine.ds.feedback.ToastTone
import com.sddamico.draftmachine.ds.forms.Button
import com.sddamico.draftmachine.ds.forms.ButtonSize
import com.sddamico.draftmachine.ds.forms.ButtonVariant
import com.sddamico.draftmachine.ds.forms.IconButton
import com.sddamico.draftmachine.ds.forms.Input
import com.sddamico.draftmachine.ds.forms.Select
import com.sddamico.draftmachine.ds.forms.Switch
import com.sddamico.draftmachine.ds.glowGlass
import com.sddamico.draftmachine.ds.roleH2
import com.sddamico.draftmachine.ds.roleH3
import com.sddamico.draftmachine.ds.roleBody
import com.sddamico.draftmachine.ds.spin
import com.sddamico.draftmachine.models.DraftDetailResponse
import com.sddamico.draftmachine.models.OnClockInfo
import com.sddamico.draftmachine.models.OwnedPlayerResponse
import com.sddamico.draftmachine.models.PendingPickInfo
import com.sddamico.draftmachine.models.PickDetail
import com.sddamico.draftmachine.models.PlayerResponse
import com.sddamico.draftmachine.models.TeamSummary
import com.sddamico.draftmachine.util.transitionTo
import kotlinx.serialization.builtins.ListSerializer
import com.sddamico.draftmachine.util.LoadState
import com.sddamico.draftmachine.util.ManagePickResult
import com.sddamico.draftmachine.util.managePick
import com.sddamico.draftmachine.util.activeMillisRemaining
import com.sddamico.draftmachine.util.formatInZone
import com.sddamico.draftmachine.util.quietWindowEndAt
import com.sddamico.draftmachine.util.EditPickResult
import com.sddamico.draftmachine.util.NudgeResult
import com.sddamico.draftmachine.util.PickResult
import com.sddamico.draftmachine.util.StartDraftResult
import com.sddamico.draftmachine.util.UNREACHABLE_MESSAGE
import com.sddamico.draftmachine.util.daysBetween
import com.sddamico.draftmachine.util.editPick
import com.sddamico.draftmachine.util.formatStampDate
import com.sddamico.draftmachine.util.formatStampDateTime
import com.sddamico.draftmachine.util.nudgeOnClock
import com.sddamico.draftmachine.util.rememberAuthState
import com.sddamico.draftmachine.util.PlayerSearchIndex
import com.sddamico.draftmachine.util.startDraft
import com.sddamico.draftmachine.util.submitPick
import com.sddamico.draftmachine.util.SkipPickResult
import com.sddamico.draftmachine.util.skipPick
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Button as DomButton
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.events.Event
import kotlin.coroutines.resume

/**
 * The draft room (design frames 1m–1p, 1s). One page for a draft's whole life: the primed SETUP
 * screen, the ACTIVE clock (from either side), and the COMPLETE "machine rests" screen. Route:
 * `/draft/{id}`. The full desktop pick board lives at `/draft/{id}/board`. Drafts are async (no live
 * socket); the page polls the detail endpoint every 30s and after each action.
 */
@Page("{id}")
@Composable
fun DraftRoomPage() {
  val ctx = rememberPageContext()
  val scope = rememberCoroutineScope()
  val auth = rememberAuthState()
  val draftId = ctx.route.params["id"].orEmpty()
  val magic = rememberMagicLink(scope)

  if (MagicLinkGate(magic, onLogin = { ctx.router.transitionTo("/login?returnTo=/draft/$draftId") })) return

  when (val s = auth.value) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> {
      LaunchedEffect(Unit) { ctx.router.transitionTo("/login?returnTo=/draft/$draftId") }
      LoadingFrame()
    }
    is LoadState.Ready -> {
      val user = s.value
      if (user == null) {
        if (magic.available) {
          LaunchedEffect(magic.token) { magic.consume() }
        } else {
          LaunchedEffect(Unit) { ctx.router.transitionTo("/login?returnTo=/draft/$draftId") }
        }
        LoadingFrame()
      } else {
        LaunchedEffect(magic.token) { magic.settle() }
        Room(draftId = draftId, email = user.email, ctx = ctx, scope = scope)
      }
    }
  }
}

@Page("{id}/board")
@Composable
fun DraftBoardPage() {
  val ctx = rememberPageContext()
  val scope = rememberCoroutineScope()
  val auth = rememberAuthState()
  val draftId = ctx.route.params["id"].orEmpty()
  val boardPath = "/draft/$draftId/board"
  val magic = rememberMagicLink(scope)

  if (MagicLinkGate(magic, onLogin = { ctx.router.transitionTo("/login?returnTo=$boardPath") })) return

  when (val authState = auth.value) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> {
      LaunchedEffect(Unit) { ctx.router.transitionTo("/login?returnTo=$boardPath") }
      LoadingFrame()
    }
    is LoadState.Ready -> {
      val user = authState.value
      if (user == null) {
        if (magic.available) {
          LaunchedEffect(magic.token) { magic.consume() }
        } else {
          LaunchedEffect(Unit) { ctx.router.transitionTo("/login?returnTo=$boardPath") }
        }
        LoadingFrame()
      } else {
        LaunchedEffect(magic.token) { magic.settle() }
        DraftBoardRoute(draftId, user.email, ctx, scope)
      }
    }
  }
}

// ── Room state & shell ──

private class RoomToast(val title: String, val message: String, val tone: ToastTone)

private const val PICK_FORMAT_WARNING =
  "The pick doesn't match the expected format: Player Name, Position, Team. Are you sure? Submit again if you're sure."

private class RoomState {
  var detail by mutableStateOf<LoadState<DraftDetailResponse>>(LoadState.Loading)
  var toast by mutableStateOf<RoomToast?>(null)
  var starting by mutableStateOf(false)
  var picking by mutableStateOf(false)
  var nudging by mutableStateOf(false)
  var skipping by mutableStateOf(false)
  var skipConfirming by mutableStateOf(false)
  var pickInput by mutableStateOf("")
  var unformattedPickConfirmation by mutableStateOf<String?>(null)
  var offPoolConfirmation by mutableStateOf<String?>(null)
  var ownedConfirmation by mutableStateOf<String?>(null)
  var pickNonce by mutableStateOf(0) // remount key that clears the pick Input after a submit
  // Resolved names of the attached player pool (null = no pool / not loaded) for autocomplete.
  var poolPlayers by mutableStateOf<List<PlayerResponse>?>(null)
  // Players already rostered in this draft's league (our player id -> owning team name), from the
  // last Fantrax ownership sync. Empty when the league has no connection.
  var ownedPlayers by mutableStateOf<Map<String, String>>(emptyMap())
  var editingPick by mutableStateOf<PickDetail?>(null)
  var editValue by mutableStateOf("")
  var editing by mutableStateOf(false)
  var editError by mutableStateOf<String?>(null)
  // Manager/admin managing one board cell: pick value, skip flag, and which team owns it.
  var managePick by mutableStateOf<PickDetail?>(null)
  var manageValue by mutableStateOf("")
  var manageSkipped by mutableStateOf(false)
  var manageTeamId by mutableStateOf("")
  // The sheet reviews the change set before applying it — trades notify the whole draft.
  var manageConfirming by mutableStateOf(false)
  var manageSaving by mutableStateOf(false)
  var manageError by mutableStateOf<String?>(null)
}

/**
 * Swaps in a fresh fetch. The first load fades in; later ones animate in place only when something
 * on screen moved — a pick landed, the clock turned over, the draft changed state — so a quiet poll
 * never interrupts someone mid-pick.
 */
private fun RoomState.show(next: LoadState<DraftDetailResponse>) {
  val current = detail
  val motion = when {
    current is LoadState.Loading -> Motion.Fade
    current is LoadState.Ready && next is LoadState.Ready && roomMoved(current.value, next.value) -> Motion.Update
    else -> null
  }
  ViewTransitions.run(motion) { detail = next }
}

private fun roomMoved(before: DraftDetailResponse, after: DraftDetailResponse): Boolean =
  before.draft.status != after.draft.status ||
    before.onClock?.position != after.onClock?.position ||
    before.pendingPick != after.pendingPick ||
    before.picks != after.picks

/** Fetches the draft detail, mapping 404/403 to machine-voice copy. */
internal suspend fun fetchDraftDetail(
  draftId: String,
  forbiddenMessage: String = "You're not on this draft's crew, so the room stays locked.",
): LoadState<DraftDetailResponse> =
  try {
    LoadState.Ready(apiGet("/api/draft-detail?draftId=$draftId", DraftDetailResponse.serializer()))
  } catch (e: ApiException) {
    val msg = when (e.status) {
      404 -> "This draft doesn't exist — or the machine never built it."
      403 -> forbiddenMessage
      else -> e.errorMessage
    }
    LoadState.Failed(msg)
  } catch (e: Throwable) {
    LoadState.Failed(e.message ?: UNREACHABLE_MESSAGE)
  }

private suspend fun fetchLeagueOwnership(draftId: String): Map<String, String>? =
  try {
    apiGet(
      "/api/league-ownership?draftId=$draftId",
      ListSerializer(OwnedPlayerResponse.serializer()),
    ).mapNotNull { owned ->
      owned.playerId?.let { it to owned.ownerTeamName }
    }.toMap()
  } catch (_: Throwable) {
    null
  }

/**
 * Re-fetch the draft every 30s while the tab is visible. A tab left open in the background used to
 * poll all night (110+ requests an hour from one client); now it waits, and catches up as soon as
 * it's shown again.
 */
@Composable
private fun PollDraftDetail(draftId: String, state: RoomState) {
  LaunchedEffect(draftId) {
    while (true) {
      delay(30_000)
      if (documentHidden()) awaitDocumentVisible()
      val next = fetchDraftDetail(draftId)
      if (next is LoadState.Ready) state.show(next)
    }
  }
}

// Kotlin's DOM bindings don't declare Document.hidden.
private fun documentHidden(): Boolean = document.asDynamic().hidden == true

private suspend fun awaitDocumentVisible() = suspendCancellableCoroutine { cont ->
  lateinit var listener: (Event) -> Unit
  listener = {
    if (!documentHidden()) {
      document.removeEventListener("visibilitychange", listener)
      cont.resume(Unit)
    }
  }
  document.addEventListener("visibilitychange", listener)
  cont.invokeOnCancellation { document.removeEventListener("visibilitychange", listener) }
}

@Composable
private fun Room(
  draftId: String,
  email: String,
  ctx: PageContext,
  scope: CoroutineScope,
) {
  val state = remember(draftId) { RoomState() }

  suspend fun refresh() {
    state.show(fetchDraftDetail(draftId))
  }

  LaunchedEffect(draftId) { refresh() }
  // Async drafts have no live channel — poll for others' picks. Silent: never clobber a Ready view
  // with a transient error.
  PollDraftDetail(draftId, state)
  // Load the attached pool's resolved player set once for pick autocomplete + off-pool detection.
  val poolId = (state.detail as? LoadState.Ready)?.value?.draft?.playerPoolId
  LaunchedEffect(poolId) {
    if (poolId == null) {
      state.poolPlayers = null
      return@LaunchedEffect
    }
    state.poolPlayers = try {
      apiGet("/api/pool-resolve?poolId=$poolId", ListSerializer(PlayerResponse.serializer()))
    } catch (_: Throwable) {
      null // Autocomplete is best-effort; the free-text path still works without it.
    }
  }
  // League-level ownership, so the autocomplete can gray out players someone already rosters.
  // Best-effort: a failure just leaves the suggestions unannotated, and the server blocks the pick
  // regardless.
  LaunchedEffect(draftId) {
    fetchLeagueOwnership(draftId)?.let { state.ownedPlayers = it }
  }
  // Ownership changes only after a connected league sync, so refresh less often than draft detail.
  // Silent: never clobber the last good ownership map with a transient error.
  LaunchedEffect(draftId) {
    while (true) {
      delay(300_000)
      fetchLeagueOwnership(draftId)?.let { state.ownedPlayers = it }
    }
  }
  // Auto-dismiss confirmations after a beat (errors linger until closed or replaced).
  LaunchedEffect(state.toast) {
    val t = state.toast
    if (t != null && t.tone != ToastTone.Rust) {
      delay(4_000)
      if (state.toast === t) state.toast = null
    }
  }

  when (val d = state.detail) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> RoomError(email, d.message, onBack = { ctx.router.transitionTo("/") })
    is LoadState.Ready -> {
      val detail = d.value
      val canManage = canManagePicks(detail)
      LaunchedEffect(canManage) {
        if (!canManage && !state.manageSaving) closePickManage(state)
      }
      MobileFrame(
          modifier = Modifier.displayFlex().flexDirection(FlexDirection.Column),
          header = {
            AppHeader(
              email = email,
              title = detail.leagueName ?: "Draft room",
              onBack = { ctx.router.transitionTo("/") },
            )
          },
        ) {
          when (detail.draft.status) {
            DraftStatus.SETUP -> PrimedBody(
              detail = detail,
              state = state,
              scope = scope,
              onRefresh = { scope.launch { refresh() } },
              onSettings = { ctx.router.transitionTo("/draft/$draftId/settings") },
              onResumeLottery = { ctx.router.transitionTo("/draft/new?resume=$draftId") },
            )
            DraftStatus.ACTIVE -> ActiveBody(
              detail = detail,
              state = state,
              scope = scope,
              onRefresh = { scope.launch { refresh() } },
              onSettings = { ctx.router.transitionTo("/draft/$draftId/settings") },
              onOpenBoard = { ctx.router.transitionTo("/draft/$draftId/board") },
            )
            DraftStatus.COMPLETE -> RestsBody(detail, state) { ctx.router.transitionTo("/draft/$draftId/board") }
            DraftStatus.CANCELLED -> CancelledBody(detail) { ctx.router.transitionTo("/draft/$draftId/board") }
          }
        }
      Presence(state.editingPick) { pick ->
        EditPickModal(
          detail = detail,
          pick = pick,
          state = state,
          onDismiss = {
            if (!state.editing) {
              state.editingPick = null
              state.editError = null
            }
          },
          onSave = {
            if (!state.editing) scope.launch {
              state.editing = true
              state.editError = null
              when (val result = editPick(detail.draft.id, pick.position, state.editValue)) {
                is EditPickResult.Success -> {
                  state.editingPick = null
                  state.toast = RoomToast("Pick updated", "The correction is now on the board.", ToastTone.Verde)
                  refresh()
                }
                is EditPickResult.Failure -> state.editError = result.message
              }
              state.editing = false
            }
          },
        )
      }
      Presence(state.managePick) { pick ->
        ManagePickModal(
          detail = detail,
          pick = pick,
          state = state,
          onDismiss = { if (!state.manageSaving) closePickManage(state) },
          onApply = {
            applyManagePick(
              scope = scope,
              state = state,
              detail = detail,
              pick = pick,
              draftId = draftId,
              fetchLatest = { fetchDraftDetail(draftId) },
              refresh = { refresh() },
            )
          },
        )
      }
      ToastLayer(state)
    }
  }
}

@Composable
private fun DraftBoardRoute(draftId: String, email: String, ctx: PageContext, scope: CoroutineScope) {
  val state = remember(draftId) { RoomState() }

  suspend fun refresh() {
    state.show(fetchDraftDetail(draftId))
  }

  LaunchedEffect(draftId) { refresh() }
  PollDraftDetail(draftId, state)
  LaunchedEffect(state.toast) {
    val toast = state.toast
    if (toast != null && toast.tone != ToastTone.Rust) {
      delay(4_000)
      if (state.toast === toast) state.toast = null
    }
  }

  when (val detailState = state.detail) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> RoomError(email, detailState.message, onBack = { ctx.router.transitionTo("/draft/$draftId") })
    is LoadState.Ready -> {
      val detail = detailState.value
      if (detail.draft.status == DraftStatus.SETUP) {
        LaunchedEffect(draftId) { ctx.router.transitionTo("/draft/$draftId") }
        LoadingFrame()
        return
      }
      // A poll can revoke the permission mid-sheet (another admin's off-pool entry pauses the
      // draft). The board's gears vanish on their own; the open sheet has to be told.
      val canManage = canManagePicks(detail)
      LaunchedEffect(canManage) {
        if (!canManage && !state.manageSaving) closePickManage(state)
      }
      BoardView(
        detail, state, scope, draftId, email,
        onExit = { ctx.router.transitionTo("/draft/$draftId") },
        onAccount = { ctx.router.transitionTo("/settings") },
      )
      Presence(state.editingPick) { pick ->
        EditPickModal(
          detail = detail,
          pick = pick,
          state = state,
          onDismiss = {
            if (!state.editing) {
              state.editingPick = null
              state.editError = null
            }
          },
          onSave = {
            if (!state.editing) scope.launch {
              state.editing = true
              state.editError = null
              when (val result = editPick(detail.draft.id, pick.position, state.editValue)) {
                is EditPickResult.Success -> {
                  state.editingPick = null
                  state.toast = RoomToast("Pick updated", "The correction is now on the board.", ToastTone.Verde)
                  refresh()
                }
                is EditPickResult.Failure -> state.editError = result.message
              }
              state.editing = false
            }
          },
        )
      }
      Presence(state.managePick) { pick ->
        ManagePickModal(
          detail = detail,
          pick = pick,
          state = state,
          onDismiss = { if (!state.manageSaving) closePickManage(state) },
          onApply = {
            applyManagePick(
              scope = scope,
              state = state,
              detail = detail,
              pick = pick,
              draftId = draftId,
              fetchLatest = { fetchDraftDetail(draftId) },
              refresh = { refresh() },
            )
          },
        )
      }
      ToastLayer(state)
    }
  }
}

@Composable
private fun RoomError(email: String, message: String, onBack: () -> Unit) {
  MobileFrame(
    modifier = Modifier.displayFlex().flexDirection(FlexDirection.Column),
    header = { AppHeader(email = email, title = "Draft room", onBack = onBack) },
  ) {
    Div(
      attrs = Modifier.flex(1).displayFlex().flexDirection(FlexDirection.Column)
        .alignItems(AlignItems.Center).justifyContent(JustifyContent.Center).gap(14.px)
        .padding(32.px).toAttrs()
    ) {
      Icon("wrench", IconWeight.Bold, Modifier.fontSize(40.px).color(DmColor.steel600))
      SpanText(
        message,
        Modifier.roleH3().color(DmColor.textSecondary).styleModifier { property("text-align", "center") },
      )
      Button("Back to the machine room", variant = ButtonVariant.Secondary, icon = "arrow-left", onClick = onBack)
    }
  }
}

// ── Shared body scaffolding ──

@Composable
private fun BodyColumn(padTop: Int = 22, align: Boolean = false, content: @Composable () -> Unit) {
  Div(
    attrs = Modifier.flex(1).displayFlex().flexDirection(FlexDirection.Column).gap(14.px)
      .padding(top = padTop.px, leftRight = 16.px, bottom = 24.px)
      .then(if (align) Modifier.alignItems(AlignItems.Center).styleModifier { property("text-align", "center") } else Modifier)
      .toAttrs()
  ) {
    PushNotificationBanner()
    content()
  }
}

@Composable
private fun SectionLabel(text: String) {
  SpanText(text, Modifier.dmStamp().color(DmColor.textMuted).displayBlock())
}

/** The "machine" display heading used on 1m / 1p — Bungee, 26px. */
@Composable
private fun MachineHeading(text: String) {
  SpanText(
    text,
    Modifier.fontFamily(*DmType.display).fontSize(26.px).lineHeight(1.1).color(DmColor.text).displayBlock(),
  )
}

/** The spinning-gear + label eyebrow stamp shared by the on-clock surfaces. */
@Composable
private fun ClockEyebrow(label: String, color: Color, gearSize: Int = 12) {
  Div(
    attrs = Modifier.displayInlineFlex().alignItems(AlignItems.Center).gap(6.px)
      .dmStamp().color(color).margin(bottom = 6.px).toAttrs()
  ) {
    Icon("gear-six", IconWeight.Fill, Modifier.fontSize(gearSize.px).color(DmColor.glass400).spin("9s"))
    SpanText(label)
  }
}

// ── 1m · SETUP — "The machine is primed" ──

@Composable
private fun PrimedBody(
  detail: DraftDetailResponse,
  state: RoomState,
  scope: CoroutineScope,
  onRefresh: () -> Unit,
  onSettings: () -> Unit,
  onResumeLottery: () -> Unit,
) {
  val roundOne = detail.picks.filter { it.round == 1 }.sortedBy { it.position }
  BodyColumn {
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.SpaceBetween)
        .toAttrs(),
    ) {
      StatusBadge(detail.draft.status, Modifier.changeCue(ChangeCue.Stamp, detail.draft.status))
      IconButton(
        icon = "gear",
        label = "Draft settings",
        variant = ButtonVariant.Ghost,
        size = ButtonSize.Sm,
        onClick = onSettings,
      )
    }

    MachineHeading("The machine is primed")
    SpanText(
      "${detail.teams.size} teams locked in. ${detail.totalPicks} picks loaded. Starting emails " +
        "the first owner their pick link.",
      Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).lineHeight(1.55),
    )

    // While a lottery reveal is in progress the written picks would spoil the undrawn slots.
    if (roundOne.isNotEmpty() && !detail.lotteryPending) {
      Div(attrs = Modifier.dmPanel().padding(14.px).toAttrs()) {
        SpanText(
          "Round 1 order" + (orderWord(detail)?.let { " · $it" } ?: ""),
          Modifier.dmStamp().color(DmColor.textMuted).displayBlock().margin(bottom = 10.px),
        )
        Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(8.px).toAttrs()) {
          roundOne.take(5).forEach { OrderRow(it) }
          if (roundOne.size > 5) {
            SpanText(
              "+ ${roundOne.size - 5} MORE",
              Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.steel500)
                .displayBlock().padding(left = 34.px),
            )
          }
        }
      }
    }

    if (detail.youCanManage && detail.lotteryPending) {
      Button(
        "Continue the lottery", variant = ButtonVariant.Primary, size = ButtonSize.Lg, icon = "dice-five",
        fullWidth = true, onClick = onResumeLottery,
      )
      SpanText(
        "The draw is safe on the server — pick up right where you left off.",
        Modifier.dmStamp().color(DmColor.steel500).displayBlock().styleModifier { property("text-align", "center") },
      )
    } else if (detail.youCanManage) {
      Button(
        "Start the draft", variant = ButtonVariant.Primary, size = ButtonSize.Lg, icon = "lightning",
        fullWidth = true, loading = state.starting,
        onClick = {
          if (!state.starting) scope.launch {
            state.starting = true
            when (val r = startDraft(detail.draft.id)) {
              is StartDraftResult.Success -> {
                state.toast = RoomToast("Machine started", "The first owner has their pick link.", ToastTone.Verde)
                onRefresh()
              }
              is StartDraftResult.Failure ->
                state.toast = RoomToast("Couldn't start", r.message, ToastTone.Rust)
            }
            state.starting = false
          }
        },
      )
      SpanText(
        "League manager or draft admin",
        Modifier.dmStamp().color(DmColor.steel500).displayBlock().styleModifier { property("text-align", "center") },
      )
    } else {
      Div(attrs = Modifier.dmPanel().padding(14.px).toAttrs()) {
        SpanText(
          "Only the league manager or a draft admin can throw the switch. You'll get an email the moment it's your " +
            "turn to pick — no need to sit here watching the gauges.",
          Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textSecondary).lineHeight(1.55),
        )
      }
    }
  }
}

@Composable
private fun OrderRow(pick: PickDetail) {
  Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px).toAttrs()) {
    SpanText(
      pick.position.toString().padStart(2, '0'),
      Modifier.fontFamily(*DmType.mono).fontSize(12.px).fontWeight(DmType.weightBold)
        .color(DmColor.brass400).width(22.px).flex("0 0 auto"),
    )
    Avatar(name = pick.ownerName, size = AvatarSize.Sm)
    Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
      SpanText(
        pick.teamName,
        Modifier.fontFamily(*DmType.body).fontSize(13.px).fontWeight(DmType.weightSemibold)
          .color(DmColor.text).displayBlock(),
      )
      if (pick.skipped) {
        SpanText("Skipped", Modifier.dmStamp().color(DmColor.steel400).displayBlock())
      } else if (pick.timedOutAt != null && !pick.filled) {
        SpanText("Timed out · pick still available", Modifier.dmStamp().color(DmColor.rust300).displayBlock())
      } else if (pick.origin != null) PickOriginStamp(pick.origin!!, pick.originTeamName)
    }
    SpanText(
      pick.ownerName,
      Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).flex("0 0 auto"),
    )
  }
}

// ── 1n / 1o · ACTIVE ──

@Composable
private fun ActiveBody(
  detail: DraftDetailResponse,
  state: RoomState,
  scope: CoroutineScope,
  onRefresh: () -> Unit,
  onSettings: () -> Unit,
  onOpenBoard: () -> Unit,
) {
  val onClock = detail.onClock
  val overdue = detail.picks.filter {
    it.teamId in detail.yourTeamIds && !it.resolved && it.timedOutAt != null
  }.minByOrNull { it.position }
  val actionable = overdue?.let {
    OnClockInfo(it.position, it.round, it.teamId, it.teamName, it.ownerName, it.timedOutAt, null)
  }
  BodyColumn(padTop = 20) {
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.SpaceBetween)
        .gap(10.px).toAttrs()
    ) {
      StatusBadge(detail.draft.status, Modifier.changeCue(ChangeCue.Stamp, detail.draft.status))
      Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(4.px).toAttrs()) {
        if (onClock != null) {
          SpanText(
            "Round ${onClock.round} · Pick ${onClock.position} of ${detail.totalPicks}",
            Modifier.dmStamp().color(DmColor.textMuted),
          )
        }
        IconButton(
          icon = "gear",
          label = "Draft settings",
          variant = ButtonVariant.Ghost,
          size = ButtonSize.Sm,
          onClick = onSettings,
        )
      }
    }

    // Off-pool pick awaiting a ruling — the wheel is paused; no picks land until a manager rules.
    val pending = detail.pendingPick
    if (pending != null) {
      PausedBanner(detail, pending, onSettings)
      BoardLink(onOpenBoard)
      LatestPicksFeed(detail) { openPickManage(state, it) }
      return@BodyColumn
    }

    if (onClock == null) {
      if (actionable != null) {
        PickPanel(detail, actionable, state, scope, onRefresh, managerOverride = false, timedOut = true)
      }
      BoardLink(onOpenBoard)
      LatestPicksFeed(detail) { openPickManage(state, it) }
      return@BodyColumn
    }

    val onClockIsYou = onClock.teamId in detail.yourTeamIds
    if (actionable != null) {
      if (actionable.position != onClock.position) OnClockCard(detail, onClock, state, scope, onRefresh)
      PickPanel(detail, actionable, state, scope, onRefresh, managerOverride = false, timedOut = true)
    } else if (onClockIsYou) {
      PickPanel(detail, onClock, state, scope, onRefresh, managerOverride = false)
    } else {
      OnClockCard(detail, onClock, state, scope, onRefresh)
      if (detail.youCanManage) {
        PickPanel(detail, onClock, state, scope, onRefresh, managerOverride = true)
      }
    }
    BoardLink(onOpenBoard)
    LatestPicksFeed(detail) { openPickManage(state, it) }
  }
}

/** Warning panel while an off-pool pick awaits a manager's ruling (pools frame 1j's room echo). */
@Composable
private fun PausedBanner(
  detail: DraftDetailResponse,
  pending: PendingPickInfo,
  onSettings: () -> Unit,
) {
  val label = pickLabels(detail.picks)[pending.position] ?: pending.position.toString()
  Div(
    attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px).padding(14.px)
      .borderRadius(DmEffects.radiusMd)
      .border(1.px, LineStyle.Solid, DmColor.warning)
      .backgroundColor(Color.rgba(232, 194, 74, 0.07f)).toAttrs()
  ) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.FlexStart).gap(12.px).toAttrs()) {
      Icon("pause-circle", IconWeight.Fill, Modifier.fontSize(20.px).color(DmColor.warning).margin(top = 1.px))
      Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
        SpanText(
          "Draft paused — pick $label awaits a ruling",
          Modifier.roleH3().fontSize(14.px).displayBlock(),
        )
        SpanText(
          "${pending.teamName} entered \"${pending.playerText}\" — it isn't in ${detail.pool?.name ?: "the pool"}. " +
            "No picks land until a manager rules.",
          Modifier.fontFamily(*DmType.body).fontSize(DmType.textXs).color(DmColor.textMuted)
            .lineHeight(1.5).displayBlock().margin(top = 2.px),
        )
      }
    }
    if (detail.youCanManage) {
      Button(
        "Rule on the pick", variant = ButtonVariant.Secondary, icon = "stamp", fullWidth = true,
        onClick = onSettings,
      )
    }
  }
}

/** 1n — someone else on the clock: energized panel + owner avatar + inline "your turn" / nudge. */
@Composable
private fun OnClockCard(
  detail: DraftDetailResponse,
  onClock: OnClockInfo,
  state: RoomState,
  scope: CoroutineScope,
  onRefresh: () -> Unit,
) {
  Div(
    attrs = Modifier.dmPanel().padding(16.px).border(1.px, LineStyle.Solid, DmColor.glass600)
      .backgroundImageRaw(DmEffects.gradientEnergy)
      .changeCue(ChangeCue.Ticker, onClockCue(onClock)).toAttrs()
  ) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px).toAttrs()) {
      Avatar(name = onClock.ownerName, size = AvatarSize.Lg)
      Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
        ClockEyebrow("On the clock", DmColor.glass300)
        SpanText(onClock.teamName, Modifier.roleH2().lineHeight(1.05).displayBlock())
        SpanText(
          sinceStamp(onClock),
          Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).displayBlock().margin(top = 3.px),
        )
        TimerCountdown(detail, onClock, onRefresh)
      }
    }
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.SpaceBetween)
        .gap(10.px).margin(top = 14.px).padding(top = 12.px)
        .borderTop(1.px, LineStyle.Solid, DmColor.border).toAttrs()
    ) {
      val turnsAway = picksUntilYours(detail.picks, detail.yourTeamIds, onClock.position)
      SpanText(
        if (turnsAway != null && turnsAway > 0) "Your turn in $turnsAway pick${if (turnsAway == 1) "" else "s"}"
        else "Waiting on their pick",
        Modifier.dmStamp().color(DmColor.patina300),
      )
      Button(
        "Nudge ${firstName(onClock.ownerName)}", variant = ButtonVariant.Secondary, size = ButtonSize.Sm,
        icon = "bell-ringing", loading = state.nudging,
        onClick = { if (!state.nudging) scope.launch { runNudge(detail, onClock, state) } },
      )
    }
  }
}

/**
 * Pick time left, counted in *active* time: the overnight pauses the server resolved into
 * [OnClockInfo.quietWindows] are subtracted, so the readout freezes (and says so) while the draft
 * sleeps instead of burning down a clock nobody can answer.
 */
@Composable
private fun TimerCountdown(detail: DraftDetailResponse, onClock: OnClockInfo, onExpire: () -> Unit) {
  val deadline = onClock.deadlineIso ?: return
  val deadlineMs = remember(deadline) { kotlin.js.Date(deadline).getTime() }
  val windows = onClock.quietWindows
  // The server's clock is authoritative; track its offset from this browser's so a skewed device
  // doesn't drift the readout.
  val skew = remember(deadline, detail.serverTimeIso) {
    kotlin.js.Date(detail.serverTimeIso).getTime() - kotlin.js.Date.now()
  }
  fun serverNow(): Double = kotlin.js.Date.now() + skew

  var remaining by remember(deadline, detail.serverTimeIso) {
    mutableStateOf(activeMillisRemaining(serverNow(), deadlineMs, windows))
  }
  var pausedUntil by remember(deadline, detail.serverTimeIso) {
    mutableStateOf(quietWindowEndAt(serverNow(), windows))
  }
  LaunchedEffect(deadline, detail.serverTimeIso) {
    while (remaining > 0) {
      delay(1_000)
      val now = serverNow()
      remaining = activeMillisRemaining(now, deadlineMs, windows)
      pausedUntil = quietWindowEndAt(now, windows)
    }
    onExpire()
  }

  val totalSeconds = (remaining / 1000).toLong().coerceAtLeast(0)
  val hours = totalSeconds / 3600
  val minutes = (totalSeconds % 3600) / 60
  val seconds = totalSeconds % 60
  fun two(value: Long) = value.toString().padStart(2, '0')
  val text = if (hours > 0) "$hours:${two(minutes)}:${two(seconds)}" else "${two(minutes)}:${two(seconds)}"

  pausedUntil?.let { until ->
    Div(
      attrs = Modifier.displayInlineFlex().alignItems(AlignItems.Center).gap(5.px)
        .margin(top = 6.px).padding(topBottom = 3.px, leftRight = 8.px)
        .borderRadius(DmEffects.radiusSm)
        .border(1.px, LineStyle.Solid, DmColor.patina600)
        .backgroundColor(Color.rgba(47, 166, 168, 0.09f)).toAttrs()
    ) {
      Icon("moon-stars", IconWeight.Fill, Modifier.fontSize(13.px).color(DmColor.patina300))
      SpanText(
        "PAUSED UNTIL ${formatInZone(until, detail.draft.quietHours.zone).uppercase()}",
        Modifier.fontFamily(*DmType.mono).fontSize(10.px).fontWeight(DmType.weightBold)
          .color(DmColor.patina300),
      )
    }
  }
  SpanText(
    if (pausedUntil != null) "$text of pick time remaining" else "$text remaining",
    Modifier.fontFamily(*DmType.mono).fontSize(12.px).fontWeight(DmType.weightBold)
      .color(if (pausedUntil != null) DmColor.textMuted else if (remaining <= 600_000) DmColor.rust300 else DmColor.brass300)
      .displayBlock().margin(top = 5.px),
  )
}

private suspend fun runNudge(detail: DraftDetailResponse, onClock: OnClockInfo, state: RoomState) {
  state.nudging = true
  val first = firstName(onClock.ownerName)
  state.toast = when (val r = nudgeOnClock(detail.draft.id)) {
    is NudgeResult.Success -> RoomToast("Nudge sent", "We pinged $first their pick link.", ToastTone.Verde)
    is NudgeResult.RateLimited -> RoomToast("Easy on the lever", r.message, ToastTone.Patina)
    is NudgeResult.Failure -> RoomToast("Couldn't nudge", r.message, ToastTone.Rust)
  }
  state.nudging = false
}

/** 1o — the make-a-pick surface. [managerOverride] frames it as the LM filling someone else's pick. */
@Composable
private fun PickPanel(
  detail: DraftDetailResponse,
  onClock: OnClockInfo,
  state: RoomState,
  scope: CoroutineScope,
  onRefresh: () -> Unit,
  managerOverride: Boolean,
  timedOut: Boolean = false,
) {
  if (!managerOverride) {
    Div(
      attrs = Modifier.padding(topBottom = 18.px, leftRight = 16.px).borderRadius(DmEffects.radiusMd)
        .border(2.px, LineStyle.Solid, DmColor.glass500)
        .backgroundColor(Color.rgba(47, 166, 168, 0.08f))
        .backgroundImageRaw(DmEffects.gradientEnergy).glowGlass()
        // A catch-up pick can sit beside the live clock card, so only the live one takes the role.
        .then(if (timedOut) Modifier else Modifier.changeCue(ChangeCue.Ticker, onClockCue(onClock)))
        .toAttrs()
    ) {
      ClockEyebrow(if (timedOut) "Timed-out pick" else "You're on the clock", if (timedOut) DmColor.rust300 else DmColor.glass300, gearSize = 13)
      SpanText(
        if (timedOut) "Catch up your pick" else "Make your pick",
        Modifier.fontFamily(*DmType.display).fontSize(28.px).lineHeight(1.05).color(DmColor.text)
          .displayBlock().margin(bottom = 8.px),
      )
      SpanText(
        pickMetaStamp(detail, onClock),
        Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textSecondary).displayBlock()
          .styleModifier { property("letter-spacing", "0.04em") },
      )
    }
  }

  Div(attrs = Modifier.dmPanel().padding(16.px).displayFlex().flexDirection(FlexDirection.Column).gap(12.px).toAttrs()) {
    if (managerOverride) {
      SpanText("Manager override · ${onClock.teamName}", Modifier.dmStamp().color(DmColor.brass400).displayBlock())
      SpanText("Make this pick", Modifier.roleH3().displayBlock())
      SpanText(
        pickMetaStamp(detail, onClock),
        Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).displayBlock(),
      )
    }
    if (timedOut) {
      SpanText(
        "The draft moved on, but this pick is still yours.",
        Modifier.roleBody().color(DmColor.rust300).displayBlock(),
      )
    }
    if (!managerOverride && !timedOut) TimerCountdown(detail, onClock, onRefresh)
    val poolAttached = detail.draft.playerPoolId != null && state.poolPlayers != null
    val otherCategory = detail.pool?.sport == Sport.OTHER
    val claimFor = remember(detail.picks, state.ownedPlayers) {
      claimLookup(detail.picks, state.ownedPlayers)
    }
    val submit = {
      val text = state.pickInput.trim()
      val ownedClaim = if (poolAttached && detail.youCanManage) {
        poolPlayerForText(state.poolPlayers!!, text)
          ?.let(claimFor)
          ?.takeIf { it.kind == ClaimKind.Owned }
      } else {
        null
      }
      if (text.isNotEmpty() && !state.picking && !poolAttached && !otherCategory &&
        text.count { it == ',' } < 2 &&
        state.unformattedPickConfirmation != text
      ) {
        state.unformattedPickConfirmation = text
        state.toast = RoomToast("Check pick format", PICK_FORMAT_WARNING, ToastTone.Patina)
      } else if (text.isNotEmpty() && !state.picking && poolAttached && !inPool(state.poolPlayers!!, text) &&
        state.offPoolConfirmation != text
      ) {
        state.offPoolConfirmation = text
        state.toast = RoomToast(
          "Not in the pool",
          "\"$text\" isn't in ${detail.pool?.name ?: "the pool"}. Submit again to send it to the managers for a ruling — the draft pauses until they approve it.",
          ToastTone.Patina,
        )
      } else if (text.isNotEmpty() && !state.picking && ownedClaim != null &&
        state.ownedConfirmation != text
      ) {
        state.ownedConfirmation = text
        state.toast = RoomToast(
          "Owned by ${ownedClaim.teamName}",
          "Fantrax says ${ownedClaim.teamName} already rosters \"$text\". Submit again to override league ownership and make the pick.",
          ToastTone.Rust,
        )
      } else if (text.isNotEmpty() && !state.picking) scope.launch {
        val overrideOwnership = ownedClaim != null && state.ownedConfirmation == text
        state.unformattedPickConfirmation = null
        state.offPoolConfirmation = null
        state.ownedConfirmation = null
        state.toast = null
        state.picking = true
        when (
          val r = submitPick(
            detail.draft.id,
            onClock.position,
            text,
            overrideOwnership = overrideOwnership,
          )
        ) {
          is PickResult.Success -> {
            state.pickInput = ""
            state.pickNonce += 1
            state.ownedConfirmation = null
            if (r.response.pending) {
              state.toast = RoomToast(
                "Sent for a ruling",
                "The pick went to the managers. The wheel is paused until one of them rules.",
                ToastTone.Patina,
              )
            }
            onRefresh()
          }
          is PickResult.Failure -> state.toast = RoomToast("Pick didn't lock", r.message, ToastTone.Rust)
        }
        state.picking = false
      }
      Unit
    }
    key(state.pickNonce) {
      Input(
        placeholder = if (otherCategory) "Enter a pick" else "e.g. Bijan Robinson, RB, ATL",
        icon = "user",
        value = state.pickInput,
        onValueChange = {
          state.pickInput = it
          if (state.unformattedPickConfirmation != it.trim()) state.unformattedPickConfirmation = null
          if (state.offPoolConfirmation != it.trim()) state.offPoolConfirmation = null
          if (state.ownedConfirmation != it.trim()) state.ownedConfirmation = null
          state.skipConfirming = false
        },
        onEnter = submit,
      )
    }
    if (poolAttached) {
      PoolSuggestions(
        players = state.poolPlayers!!,
        query = state.pickInput,
        claimFor = claimFor,
        onPick = { p ->
          state.pickInput = suggestionText(p, structured = !otherCategory)
          state.ownedConfirmation = null
          state.pickNonce += 1
        },
      )
    }
    Button(
      "Make pick", variant = ButtonVariant.Primary, size = ButtonSize.Lg, icon = "lightning",
      fullWidth = true, loading = state.picking, disabled = state.pickInput.isBlank(),
      onClick = { submit() },
    )
    if (!timedOut) {
      Button(
        "Skip pick", variant = ButtonVariant.Secondary, size = ButtonSize.Lg, icon = "prohibit",
        fullWidth = true, loading = state.skipping,
        onClick = {
          if (!state.skipConfirming) {
            state.skipConfirming = true
            state.toast = RoomToast(
              "Skip this pick?",
              "This can't be undone from here — the clock moves on immediately. Click Skip pick again to confirm.",
              ToastTone.Patina,
            )
          } else scope.launch {
            state.skipConfirming = false
            state.skipping = true
            when (val r = skipPick(detail.draft.id, onClock.position)) {
              is SkipPickResult.Success -> {
                state.toast = null
                state.pickInput = ""
                state.pickNonce += 1
                onRefresh()
              }
              is SkipPickResult.Failure -> state.toast = RoomToast("Couldn't skip", r.message, ToastTone.Rust)
            }
            state.skipping = false
          }
        },
      )
    }
  }
}

// ── Pool autocomplete + off-pool helpers ──

/** Why a suggested player is already claimed, and by whom. */
private enum class ClaimKind(val stamp: String) {
  Drafted("DRAFTED BY"),
  Owned("OWNED BY"),
}

private data class PlayerClaim(val kind: ClaimKind, val teamName: String)

private val WHITESPACE_RUN = Regex("\\s+")

/** Normalized form used to match player names across picks, pool entries and typed text. */
private fun normalizeName(text: String): String =
  text.trim().replace(WHITESPACE_RUN, " ").lowercase()

/** Same, but keeps only the name segment of a "Name, POS, TEAM" entry. */
private fun normalizeClaimName(text: String): String = normalizeName(text.substringBefore(","))

/**
 * Resolves who has already taken a player: someone in *this* draft, or a team that rosters them in
 * the linked league. A pick made here wins over league ownership, because the two disagree exactly
 * when a player was just drafted and the owning team hasn't added them in Fantrax yet — and "drafted
 * by" is the truer statement at that moment.
 *
 * Picks are matched by player id, falling back to the normalized name so free-text and off-pool
 * entries still register.
 */
private fun claimLookup(
  picks: List<PickDetail>,
  ownedPlayers: Map<String, String>,
): (PlayerResponse) -> PlayerClaim? {
  val draftedById = mutableMapOf<String, String>()
  val draftedByName = mutableMapOf<String, String>()
  picks.forEach { pick ->
    if (pick.skipped) return@forEach
    // First pick wins if a player somehow appears twice, so the label stays stable.
    pick.playerId?.let { if (it !in draftedById) draftedById[it] = pick.teamName }
    pick.playerText?.let {
      val key = normalizeClaimName(it)
      if (key.isNotEmpty() && key !in draftedByName) draftedByName[key] = pick.teamName
    }
  }

  return { player ->
    val drafted = draftedById[player.id] ?: draftedByName[normalizeClaimName(player.name)]
    when {
      drafted != null -> PlayerClaim(ClaimKind.Drafted, drafted)
      else -> ownedPlayers[player.id]?.let { PlayerClaim(ClaimKind.Owned, it) }
    }
  }
}

/** Normalized match of typed text (or its name segment before the first comma) against pool names. */
private fun inPool(players: List<PlayerResponse>, text: String): Boolean {
  return poolPlayerForText(players, text) != null
}

private fun poolPlayerForText(players: List<PlayerResponse>, text: String): PlayerResponse? {
  val normalized = normalizeName(text)
  val nameOnly = normalizeClaimName(text)
  return players.firstOrNull {
    val n = normalizeName(it.name)
    n == normalized || n == nameOnly
  }
}

/** Fill the pick input the way the room asks for picks: "Name, POS, TEAM" (parts optional). */
private fun suggestionText(p: PlayerResponse, structured: Boolean): String =
  if (structured) {
    listOfNotNull(p.name, p.position?.takeIf { it.isNotBlank() }, playerTeamLabel(p))
      .joinToString(", ")
  } else {
    p.name
  }

/** Typeahead rows under the pick input, filtered from the attached pool's resolved players. */
@Composable
private fun PoolSuggestions(
  players: List<PlayerResponse>,
  query: String,
  claimFor: (PlayerResponse) -> PlayerClaim?,
  onPick: (PlayerResponse) -> Unit,
) {
  val index = remember(players) { PlayerSearchIndex(players) }
  // The index stays pure and pool-keyed; picks and ownership both change independently of the pool,
  // so sink claimed players here rather than teaching the search about them.
  // Resolve each claim once, then sort and render off the pair — claimFor was previously called
  // twice per suggestion on every keystroke.
  val matches = remember(index, query) { index.search(query) }
    .map { it to claimFor(it) }
    .sortedBy { (_, claim) -> claim != null }
  if (matches.isEmpty()) return
  // Once the input already spells out the only remaining match, the list is just noise.
  if (matches.size == 1) {
    val only = matches[0].first
    val typed = query.trim()
    if (typed.equals(only.name.trim(), ignoreCase = true) ||
      typed.equals(suggestionText(only, structured = true).trim(), ignoreCase = true)
    ) return
  }

  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(4.px).toAttrs()) {
    matches.forEach { (p, claim) ->
      val selectable = claim == null
      val rowBase = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px)
        .padding(topBottom = 8.px, leftRight = 12.px)
        .border(1.px, LineStyle.Solid, DmColor.border)
        .borderRadius(DmEffects.radiusSm)
        .backgroundColor(DmColor.surfaceInset)
      Div(
        attrs = (if (selectable) rowBase.cursor(Cursor.Pointer) else rowBase)
          .toAttrs {
            if (selectable) {
              attr("role", "button")
              onClick { onPick(p) }
            } else {
              attr("aria-disabled", "true")
            }
          }
      ) {
        Icon(
          if (claim == null) "magnifying-glass" else "lock-simple",
          IconWeight.Regular,
          Modifier.fontSize(13.px).color(DmColor.textMuted),
        )
        SpanText(
          p.name,
          Modifier.flex(1).minWidth(0.px).fontFamily(*DmType.body).fontSize(13.px)
            .fontWeight(DmType.weightSemibold)
            .color(if (claim == null) DmColor.text else DmColor.textMuted),
        )
        if (claim != null) {
          SpanText(
            "${claim.kind.stamp} ${claim.teamName.uppercase()}",
            Modifier.dmStamp().color(DmColor.rust300),
          )
        } else {
          SpanText(
            listOfNotNull(p.position?.takeIf { it.isNotBlank() }, playerTeamLabel(p))
              .joinToString(" · "),
            Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted),
          )
        }
      }
    }
  }
}

// ── Latest picks feed (1n / 1o / 1p) ──

@Composable
private fun LatestPicksFeed(detail: DraftDetailResponse, onManage: (PickDetail) -> Unit) {
  val recent = detail.picks.filter { it.filled }.sortedByDescending { it.pickedAt ?: "" }.take(5)
  if (recent.isEmpty()) return
  val labels = pickLabels(detail.picks)
  SectionLabel("Latest picks")
  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(8.px).toAttrs()) {
    recent.forEach {
      key(it.position) {
        FeedRow(it, labels[it.position] ?: it.position.toString(), canManagePicks(detail), onManage)
      }
    }
  }
}

@Composable
private fun FeedRow(
  pick: PickDetail,
  label: String,
  canManage: Boolean = false,
  onManage: (PickDetail) -> Unit = {},
) {
  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px)
      .padding(topBottom = 10.px, leftRight = 12.px)
      .border(1.px, LineStyle.Solid, DmColor.border).borderRadius(DmEffects.radiusSm)
      .backgroundColor(DmColor.surfaceInset)
      .transitionRole(TransitionRole.Item).toAttrs()
  ) {
    SpanText(
      label,
      Modifier.fontFamily(*DmType.mono).fontSize(12.px).fontWeight(DmType.weightBold)
        .color(DmColor.brass400).width(34.px).flex("0 0 auto"),
    )
    Icon(
      if (pick.skipped) "prohibit" else "user", IconWeight.Bold,
      Modifier.fontSize(16.px).color(if (pick.skipped) DmColor.steel400 else DmColor.patina300).flex("0 0 auto"),
    )
    Div(
      attrs = Modifier.flex(1).minWidth(0.px).displayFlex().flexDirection(FlexDirection.Column)
        .justifyContent(JustifyContent.Center).gap(2.px).toAttrs()
    ) {
      SpanText(
        if (pick.skipped) "Skipped" else pick.playerText ?: "(pick made)",
        Modifier.fontFamily(*DmType.body).fontSize(15.px).fontWeight(DmType.weightSemibold)
          .color(DmColor.text).lineHeight(1.2).displayBlock(),
      )
      if (pick.origin != null) PickOriginStamp(pick.origin!!, pick.originTeamName)
      EditAttribution(pick)
    }
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(4.px).flex("0 0 auto").toAttrs()) {
      SpanText(
        pick.teamName,
        Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textSecondary)
          .styleModifier { property("text-align", "right") },
      )
      if (canManage) {
        IconButton(
          icon = "gear-six", label = "Manage pick ${pick.position} · ${pick.teamName}",
          variant = ButtonVariant.Secondary, size = ButtonSize.Sm, round = true,
          onClick = { onManage(pick) },
        )
      }
    }
  }
}

// ── Board link (mobile → 1s) ──

@Composable
private fun BoardLink(onOpen: () -> Unit) {
  DomButton(
    attrs = PressableStyle.toModifier()
      .displayFlex()
      .alignItems(AlignItems.Center)
      .justifyContent(JustifyContent.SpaceBetween)
      .gap(12.px)
      .fillMaxWidth()
      .height(46.px)
      .padding(topBottom = 0.px, leftRight = 14.px)
      .backgroundColor(DmColor.brassTint(0.06f))
      .border(1.px, LineStyle.Solid, DmColor.brass600)
      .borderRadius(DmEffects.radiusMd)
      .color(DmColor.brass300)
      .cursor(Cursor.Pointer)
      .styleModifier {
        property("appearance", "none")
        property("text-align", "left")
      }
      .toAttrs { onClick { onOpen() } }
  ) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px).toAttrs()) {
      Icon("table", IconWeight.Bold, Modifier.fontSize(18.px).color(DmColor.brass400))
      SpanText(
        "View the full board",
        Modifier.fontFamily(*DmType.heading).fontSize(16.px).fontWeight(DmType.weightBold)
          .color(DmColor.brass300),
      )
    }
    Icon("caret-right", IconWeight.Bold, Modifier.fontSize(20.px).color(DmColor.brass400))
  }
}

// ── 1p · COMPLETE ──

@Composable
private fun RestsBody(detail: DraftDetailResponse, state: RoomState, onOpenBoard: () -> Unit) {
  val ordered = detail.picks.sortedBy { it.position }
  val labels = pickLabels(detail.picks)
  val progress = pickProgress(detail)
  BodyColumn(padTop = 26, align = true) {
    Badge("Draft complete", tone = BadgeTone.Verde, dot = true, modifier = Modifier.changeCue(ChangeCue.Stamp, detail.draft.status))
    Gauge(
      value = progress.made.toDouble(), max = maxOf(1, progress.available).toDouble(),
      tone = GaugeTone.Verde, size = 112, label = "${progress.made} of ${progress.available} picks",
      sweepIn = true,
    )
    MachineHeading(detail.leagueName ?: "Draft complete")
    SpanText(
      completedStamp(detail),
      Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted)
        .styleModifier { property("text-align", "center"); property("letter-spacing", "0.04em") },
    )
    Div(attrs = Modifier.displayFlex().gap(10.px).justifyContent(JustifyContent.Center).toAttrs()) {
      Button("Export results", variant = ButtonVariant.Secondary, icon = "download-simple", onClick = { exportResultsCsv(detail) })
      Button("Final board", variant = ButtonVariant.Ghost, icon = "squares-four", onClick = onOpenBoard)
    }
    Div(
      attrs = Modifier.fillMaxWidth().displayFlex().flexDirection(FlexDirection.Column).gap(8.px)
        .margin(top = 6.px).styleModifier { property("text-align", "left") }.toAttrs()
    ) {
      SectionLabel("Final picks")
      ordered.forEach {
        key(it.position) {
          FeedRow(it, labels[it.position] ?: it.position.toString(), canManagePicks(detail)) { pick ->
            openPickManage(state, pick)
          }
        }
      }
    }
  }
}

// ── CANCELLED ──

@Composable
private fun CancelledBody(detail: DraftDetailResponse, onOpenBoard: () -> Unit) {
  val made = detail.picks.count { it.filled }
  val skipped = detail.picks.count { it.skipped }
  BodyColumn(padTop = 28, align = true) {
    StatusBadge(detail.draft.status, Modifier.changeCue(ChangeCue.Stamp, detail.draft.status))
    Icon("prohibit", IconWeight.Bold, Modifier.fontSize(52.px).color(DmColor.rust400))
    MachineHeading("Draft cancelled")
    SpanText(
      "$made pick${if (made == 1) "" else "s"} made · $skipped skipped",
      Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted),
    )
    SpanText(
      "The league manager stopped this draft. Picks already made are preserved, and every remaining slot is skipped.",
      Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textSecondary).lineHeight(1.55)
        .maxWidth(340.px).styleModifier { property("text-align", "center") },
    )
    Div(attrs = Modifier.displayFlex().gap(10.px).justifyContent(JustifyContent.Center).toAttrs()) {
      Button(
        "Export results",
        variant = ButtonVariant.Secondary,
        icon = "download-simple",
        onClick = { exportResultsCsv(detail) },
      )
      Button(
        "Final board",
        variant = ButtonVariant.Ghost,
        icon = "squares-four",
        onClick = onOpenBoard,
      )
    }
  }
}

// ── 1s · desktop board grid ──

@Composable
private fun BoardView(
  detail: DraftDetailResponse,
  state: RoomState,
  scope: CoroutineScope,
  draftId: String,
  email: String,
  onExit: () -> Unit,
  onAccount: () -> Unit,
) {
  val teams = orderedTeams(detail)
  val maxRound = maxOf(detail.picks.maxOfOrNull { it.round } ?: detail.draft.rounds, detail.draft.rounds)
  val labels = pickLabels(detail.picks)
  val onClock = detail.onClock
  val canManage = canManagePicks(detail)

  Div(
    attrs = Modifier.fillMaxWidth().minHeight(100.vh).dmGridBackdrop()
      .displayFlex().flexDirection(FlexDirection.Column).toAttrs()
  ) {
    // Header bar.
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(14.px).height(62.px)
        .padding(leftRight = 24.px).fillMaxWidth()
        .borderBottom(1.px, LineStyle.Solid, DmColor.border)
        .backgroundColor(Color.rgba(22, 28, 34, 0.85f)).toAttrs()
    ) {
      IconButton("caret-left", "Back to draft", variant = ButtonVariant.Ghost, size = ButtonSize.Sm, onClick = onExit)
      Logo(variant = LogoVariant.Full, size = 22.0)
      Div(attrs = Modifier.flex(1).toAttrs()) {}
      SpanText(boardTitle(detail), Modifier.dmStamp().color(DmColor.textMuted))
      if (detail.youCanManage) {
        IconButton(
          "download-simple", "Download draft CSV",
          variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
          onClick = { exportResultsCsv(detail) },
        )
      }
      Span(
        attrs = Modifier.displayInlineFlex().cursor(Cursor.Pointer).toAttrs {
          attr("role", "button")
          attr("aria-label", "Account settings")
          attr("title", "Account settings")
          onClick { onAccount() }
        },
      ) {
        Avatar(name = email.substringBefore("@"), size = AvatarSize.Sm)
      }
    }

    Div(
      attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(16.px)
        .padding(top = 22.px, leftRight = 24.px, bottom = 26.px).fillMaxWidth().toAttrs()
    ) {
      if (onClock != null) BoardClockPanel(detail, onClock, state, scope)

      // Scrollable board.
      Div(
        attrs = Modifier.dmPanel().padding(18.px).fillMaxWidth()
          .overflow { x(Overflow.Auto); y(Overflow.Hidden) }.toAttrs()
      ) {
        BoardGrid(
          detail, teams, maxRound, labels, onClock, canManage,
          onManage = { openPickManage(state, it) },
        )
      }

    }
  }
}

@Composable
private fun BoardClockPanel(detail: DraftDetailResponse, onClock: OnClockInfo, state: RoomState, scope: CoroutineScope) {
  val progress = pickProgress(detail)
  val skippedCount = detail.picks.count { it.skipped }
  Div(
    attrs = Modifier.dmPanel().padding(topBottom = 16.px, leftRight = 20.px)
      .displayFlex().alignItems(AlignItems.Center).gap(24.px).styleModifier { property("flex-wrap", "wrap") }.toAttrs()
  ) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.FlexStart).gap(18.px).toAttrs()) {
      BoardCounter("Round", onClock.round.toString(), null)
      Div(attrs = Modifier.width(1.px).height(46.px).backgroundColor(DmColor.borderStrong).toAttrs()) {}
      BoardCounter("Pick", onClock.position.toString(), "/ ${detail.totalPicks}", subtitle = if (skippedCount > 0) "($skippedCount skipped)" else null)
    }
    Div(attrs = Modifier.width(1.px).height(52.px).backgroundColor(DmColor.border).toAttrs()) {}
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px).toAttrs()) {
      Avatar(name = onClock.ownerName, size = AvatarSize.Lg)
      Div(attrs = Modifier.toAttrs()) {
        ClockEyebrow("On the clock", DmColor.glass300)
        SpanText(
          onClock.teamName,
          Modifier.roleH2().lineHeight(1.05).displayBlock().styleModifier { property("white-space", "nowrap") },
        )
        SpanText(
          sinceStamp(onClock),
          Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).displayBlock().margin(top = 2.px),
        )
        TimerCountdown(detail, onClock) {}
      }
    }
    Div(attrs = Modifier.flex(1).toAttrs()) {}
    Gauge(
      value = progress.made.toDouble(), max = maxOf(1, progress.available).toDouble(),
      tone = GaugeTone.Glass, size = 88, label = "Picks made",
    )
    Button(
      "Nudge ${firstName(onClock.ownerName)}", variant = ButtonVariant.Secondary, icon = "bell-ringing",
      loading = state.nudging, onClick = { if (!state.nudging) scope.launch { runNudge(detail, onClock, state) } },
    )
  }
}

private data class PickProgress(val made: Int, val available: Int)

private fun pickProgress(detail: DraftDetailResponse): PickProgress = PickProgress(
  made = detail.picks.count { it.filled },
  available = detail.picks.count { !it.skipped },
)

@Composable
private fun BoardCounter(label: String, value: String, suffix: String? = null, subtitle: String? = null) {
  Div(attrs = Modifier.flex("0 0 auto").displayFlex().flexDirection(FlexDirection.Column).gap(4.px).toAttrs()) {
    SpanText(label, Modifier.dmStamp().color(DmColor.textMuted).displayBlock().margin(bottom = 4.px))
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Baseline).gap(6.px).toAttrs()) {
      SpanText(
        value,
        Modifier.fontFamily(*DmType.display).fontSize(40.px).lineHeight(0.85)
          .color(if (suffix == null) DmColor.brass400 else DmColor.text),
      )
      if (suffix != null) SpanText(suffix, Modifier.fontFamily(*DmType.mono).fontSize(13.px).color(DmColor.textMuted))
    }
    if (subtitle != null) {
      SpanText(
        subtitle,
        Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.steel500)
          .styleModifier { property("font-style", "italic") },
      )
    }
  }
}

@Composable
private fun BoardGrid(
  detail: DraftDetailResponse,
  teams: List<TeamSummary>,
  maxRound: Int,
  labels: Map<Int, String>,
  onClock: OnClockInfo?,
  canManage: Boolean,
  onManage: (PickDetail) -> Unit,
) {
  val cols = "48px repeat(${teams.size}, minmax(140px, 1fr))"
  Div(attrs = Modifier.styleModifier { property("min-width", "fit-content") }.toAttrs()) {
    // Header row: RD corner + team columns.
    Div(
      attrs = Modifier.displayGrid()
        .styleModifier { property("grid-template-columns", cols); property("gap", "10px"); property("align-items", "end") }
        .margin(bottom = 12.px).toAttrs()
    ) {
      SpanText("RD", Modifier.dmStamp().color(DmColor.steel600))
      teams.forEach { TeamHeaderCell(it, firstPosOf(detail, it.id)) }
    }
    Div(attrs = Modifier.height(1.px).backgroundColor(DmColor.border).margin(bottom = 12.px).toAttrs()) {}

    // One row per round.
    Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px).toAttrs()) {
      (1..maxRound).forEach { round ->
        Div(
          attrs = Modifier.displayGrid()
            .styleModifier { property("grid-template-columns", cols); property("gap", "10px"); property("align-items", "stretch") }
            .toAttrs()
        ) {
          Div(
            attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.Center)
              .fontFamily(*DmType.mono).fontSize(18.px).fontWeight(DmType.weightBold).color(DmColor.steel400).toAttrs()
          ) { SpanText("$round") }
          teams.forEach { team ->
            val cellPicks = detail.picks.filter { it.teamId == team.id && it.round == round }.sortedBy { it.position }
            BoardCell(cellPicks, labels, onClock, canManage, onManage)
          }
        }
      }
    }
  }
}

@Composable
private fun TeamHeaderCell(team: TeamSummary, firstPos: Int?) {
  Div(
    attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).alignItems(AlignItems.Center).gap(5.px)
      .styleModifier { property("text-align", "center") }.toAttrs()
  ) {
    Avatar(name = team.ownerName, size = AvatarSize.Sm)
    SpanText(
      team.teamName,
      Modifier.fontFamily(*DmType.mono).fontSize(10.px).color(DmColor.textSecondary).lineHeight(1.25)
        .displayBlock(),
    )
    SpanText(
      firstPos?.let { it.toString().padStart(2, '0') } ?: "",
      Modifier.fontFamily(*DmType.mono).fontSize(10.px).color(DmColor.steel500),
    )
  }
}

@Composable
private fun BoardCell(
  cellPicks: List<PickDetail>,
  labels: Map<Int, String>,
  onClock: OnClockInfo?,
  canManage: Boolean,
  onManage: (PickDetail) -> Unit,
) {
  if (cellPicks.isEmpty()) {
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.Center)
        .minHeight(46.px).fillMaxHeight().borderRadius(DmEffects.radiusSm)
        .border(1.px, LineStyle.Dashed, DmColor.borderStrong).backgroundColor(DmColor.surfaceInset)
        .fontFamily(*DmType.mono).fontSize(12.px).color(DmColor.steel600).toAttrs()
    ) { SpanText("—") }
    return
  }
  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(6.px).toAttrs()) {
    cellPicks.forEach { pick ->
      val isOnClock = onClock != null && pick.position == onClock.position
      // The gear is absolutely positioned in the corner, so the body reserves room for it.
      val base = Modifier.position(Position.Relative)
        .displayFlex().flexDirection(FlexDirection.Column).gap(3.px)
        .fillMaxHeight().minHeight(46.px).borderRadius(DmEffects.radiusSm)
        .padding(top = 9.px, bottom = 9.px, left = 10.px, right = if (canManage) 38.px else 10.px)
      val surface = when {
        isOnClock -> base.border(2.px, LineStyle.Solid, DmColor.glass500)
          .backgroundColor(Color.rgba(47, 166, 168, 0.08f)).backgroundImageRaw(DmEffects.gradientEnergy).glowGlass()
        pick.skipped -> base.border(1.px, LineStyle.Solid, DmColor.steel500).backgroundColor(DmColor.surfaceInset)
        pick.timedOutAt != null && !pick.filled -> base.border(1.px, LineStyle.Solid, DmColor.rust500)
          .backgroundColor(Color.rgba(176, 74, 47, 0.10f))
        pick.filled -> base.border(1.px, LineStyle.Solid, DmColor.border).backgroundColor(DmColor.surfaceRaised)
        else -> base.border(1.px, LineStyle.Dashed, DmColor.border).backgroundColor(DmColor.surfaceInset)
      }
      Div(attrs = surface.toAttrs()) {
        if (canManage) {
          IconButton(
            icon = "gear-six",
            label = "Manage pick ${pick.position} · ${pick.teamName}",
            variant = ButtonVariant.Secondary,
            size = ButtonSize.Sm,
            round = true,
            onClick = { onManage(pick) },
            modifier = Modifier.position(Position.Absolute).bottom(5.px).right(5.px)
              .color(DmColor.primary),
          )
        }
        when {
          isOnClock -> {
            SpanText("On the clock", Modifier.dmStamp().color(DmColor.glass300).displayBlock())
            Div(attrs = Modifier.displayInlineFlex().alignItems(AlignItems.Center).gap(5.px).toAttrs()) {
              Icon("gear-six", IconWeight.Fill, Modifier.fontSize(12.px).color(DmColor.glass400).spin("9s"))
              SpanText(
                // Named, not bare: a snake row reads left-to-right by team, so the labelled cells
                // around this one belong to later picks and the unlabelled clock looks like theirs.
                "Awaiting Pick ${labels[pick.position] ?: pick.position}…",
                Modifier.fontFamily(*DmType.body).fontSize(12.px).fontWeight(DmType.weightSemibold).color(DmColor.text),
              )
            }
            if (pick.origin != null) PickOriginStamp(pick.origin!!, pick.originTeamName)
          }
          pick.skipped -> {
            Div(attrs = Modifier.displayInlineFlex().alignItems(AlignItems.Center).gap(5.px).toAttrs()) {
              Icon("prohibit", IconWeight.Bold, Modifier.fontSize(12.px).color(DmColor.steel400))
              SpanText(
                "Skipped",
                Modifier.fontFamily(*DmType.body).fontSize(12.px).fontWeight(DmType.weightSemibold).color(DmColor.textMuted),
              )
            }
            SpanText(
              labels[pick.position] ?: pick.position.toString(),
              Modifier.fontFamily(*DmType.mono).fontSize(10.px).color(DmColor.steel500).displayBlock(),
            )
          }
          pick.timedOutAt != null && !pick.filled -> {
            SpanText("Timed out", Modifier.dmStamp().color(DmColor.rust300).displayBlock())
            SpanText(
              if (canManage) "Pick still available — make it for them" else "Pick still available",
              Modifier.roleBody().fontSize(12.px).color(DmColor.textMuted),
            )
            if (pick.origin != null) PickOriginStamp(pick.origin!!, pick.originTeamName)
          }
          pick.filled -> {
            Div(attrs = Modifier.displayInlineFlex().alignItems(AlignItems.Center).gap(5.px).minWidth(0.px).toAttrs()) {
              Icon("user", IconWeight.Bold, Modifier.fontSize(12.px).color(DmColor.patina300))
              SpanText(
                pick.playerText ?: "(pick made)",
                Modifier.fontFamily(*DmType.body).fontSize(12.px).fontWeight(DmType.weightSemibold).color(DmColor.text),
              )
            }
            if (pick.origin != null) {
              PickOriginStamp(pick.origin!!, pick.originTeamName)
            } else {
              SpanText(
                labels[pick.position] ?: pick.position.toString(),
                Modifier.fontFamily(*DmType.mono).fontSize(10.px).color(DmColor.textMuted).displayBlock(),
              )
            }
            EditAttribution(pick)
          }
          else -> {
            // A pick traded before it is made is the case the stamp matters most for — it is the
            // only thing on the board saying this slot is not where the order originally put it.
            if (pick.origin != null) {
              PickOriginStamp(pick.origin!!, pick.originTeamName)
            } else {
              SpanText(
                labels[pick.position] ?: pick.position.toString(),
                Modifier.fontFamily(*DmType.mono).fontSize(10.px).color(DmColor.steel500).displayBlock(),
              )
            }
            SpanText(
              "Awaiting pick…",
              Modifier.fontFamily(*DmType.body).fontSize(12.px).color(DmColor.textMuted),
            )
          }
        }
      }
    }
  }
}

private fun openPickEditor(state: RoomState, pick: PickDetail) {
  state.editingPick = pick
  state.editValue = pick.playerText.orEmpty()
  state.editError = null
}

/**
 * Managers/admins may reassign, skip and fill any pick on the board, but not before the draft
 * starts (the wizard owns the order then) and not while an off-pool ruling has the draft paused —
 * `/api/draft-pick-manage` 409s on both. Shared by the board (which shows the gears) and its route
 * (which closes an open sheet when a poll revokes the permission), so the two can never disagree.
 */
private fun canManagePicks(detail: DraftDetailResponse): Boolean =
  detail.youCanManage && detail.draft.status != DraftStatus.SETUP && detail.pendingPick == null

private fun openPickManage(state: RoomState, pick: PickDetail) {
  state.managePick = pick
  state.manageValue = pick.playerText.orEmpty()
  state.manageSkipped = pick.skipped
  state.manageTeamId = pick.teamId
  state.manageConfirming = false
  state.manageError = null
}

// A trade can hand the pick that is up to another team without the position moving.
private fun onClockCue(onClock: OnClockInfo) = "${onClock.position}-${onClock.teamId}"

// The rest of the sheet's fields are left as they are so it leaves showing what was on it;
// openPickManage resets them.
private fun closePickManage(state: RoomState) {
  state.managePick = null
}

private fun applyManagePick(
  scope: CoroutineScope,
  state: RoomState,
  detail: DraftDetailResponse,
  pick: PickDetail,
  draftId: String,
  fetchLatest: suspend () -> LoadState<DraftDetailResponse>,
  refresh: suspend () -> Unit,
) {
  if (state.manageSaving) return
  scope.launch {
    state.manageSaving = true
    state.manageError = null
    // Read the fields once, up front: the request suspends, and anything typed while it is in
    // flight would otherwise make the toast quote a change that was never sent.
    val changes = pendingPickChanges(pick, state)
    // `pick` is a snapshot from when the sheet opened, but the room only polls every 30s and the
    // team's own owner can fill a pick at any time. makePick overwrites a filled pick without
    // complaint and, unlike the edit path, records no PickEdits row — so their entry would vanish
    // leaving no trail. A reassignment of an already-filled pick is legitimate, so only a *value*
    // write trips this guard.
    val latest = fetchLatest()
    if (latest is LoadState.Ready) state.detail = latest
    val current = (latest as? LoadState.Ready)?.value
      ?.picks?.firstOrNull { it.position == pick.position }
    val stolen = changes.playerText != null && !pick.filled && current?.filled == true
    if (stolen) {
      state.manageError =
        "${pick.teamName} just made this pick themselves — reopen the gear to correct it instead."
    } else when (
      val result = managePick(
        draftId = detail.draft.id,
        position = pick.position,
        playerText = changes.playerText,
        teamId = changes.teamId,
        skipped = changes.skipped,
      )
    ) {
      is ManagePickResult.Success -> {
        closePickManage(state)
        state.toast = manageToast(pick, detail, changes, result)
        refresh()
      }
      is ManagePickResult.Failure -> state.manageError = result.message
    }
    state.manageSaving = false
  }
}

/** The three independent edits the manage sheet can send; null means "leave this alone". */
private data class PickChanges(
  val playerText: String?,
  val teamId: String?,
  val skipped: Boolean?,
) {
  val any: Boolean get() = playerText != null || teamId != null || skipped != null
}

private fun pendingPickChanges(pick: PickDetail, state: RoomState): PickChanges {
  val value = state.manageValue.trim()
  // Skipping and setting a value are mutually exclusive, so a skip drops any typed value rather
  // than sending a pair the server would have to reject.
  val skipping = state.manageSkipped != pick.skipped
  return PickChanges(
    playerText = value.takeIf { !state.manageSkipped && it.isNotEmpty() && it != pick.playerText.orEmpty().trim() },
    teamId = state.manageTeamId.takeIf { it.isNotBlank() && it != pick.teamId },
    skipped = state.manageSkipped.takeIf { skipping },
  )
}

private fun manageToast(
  pick: PickDetail,
  detail: DraftDetailResponse,
  changes: PickChanges,
  result: ManagePickResult.Success,
): RoomToast {
  val newTeam = changes.teamId?.let { id -> detail.teams.firstOrNull { it.id == id }?.teamName }
  return when {
    result.response.pending -> RoomToast(
      "Sent for a ruling",
      "\"${changes.playerText}\" isn't in ${detail.pool?.name ?: "the pool"}, so it went to the " +
        "managers. The wheel is paused until one of them rules.",
      ToastTone.Patina,
    )
    newTeam != null -> RoomToast(
      "Pick traded",
      "${pick.teamName} → $newTeam. The whole draft has been told.",
      ToastTone.Verde,
    )
    changes.skipped == true ->
      RoomToast("Pick skipped", "${pick.teamName} won't come to the clock for it.", ToastTone.Verde)
    changes.skipped == false ->
      RoomToast("Pick restored", "${pick.teamName} is back in line for it.", ToastTone.Verde)
    else -> RoomToast("Pick updated", "The board is up to date.", ToastTone.Verde)
  }
}

@Composable
private fun EditAttribution(pick: PickDetail) {
  val editor = pick.editedBy ?: return
  val timestamp = pick.editedAt?.let { formatStampDateTime(it) }?.takeIf { it.isNotEmpty() }
  SpanText(
    listOfNotNull("Edited by $editor", timestamp).joinToString(" · "),
    Modifier.fontFamily(*DmType.mono).fontSize(10.px).color(DmColor.brass300).displayBlock(),
  )
}

@Composable
private fun EditPickModal(
  detail: DraftDetailResponse,
  pick: PickDetail,
  state: RoomState,
  onDismiss: () -> Unit,
  onSave: () -> Unit,
) {
  val label = pickLabels(detail.picks)[pick.position] ?: pick.position.toString()
  val unchanged = state.editValue.trim() == pick.playerText.orEmpty().trim()
  PanelDialog(labelledBy = "edit-pick-title", onDismiss = onDismiss) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px).toAttrs()) {
      Icon("pencil-simple", IconWeight.Bold, Modifier.fontSize(26.px).color(DmColor.brass400))
      Div(attrs = Modifier.toAttrs { id("edit-pick-title") }) {
        SpanText("Edit pick", Modifier.roleH2().displayBlock())
      }
    }
    Div(attrs = Modifier.dmPanel().padding(12.px).displayFlex().flexDirection(FlexDirection.Column).gap(5.px).toAttrs()) {
      SpanText("${pick.teamName} · ${pick.ownerName}", Modifier.roleH3().displayBlock())
      SpanText(
        "ROUND ${pick.round} · PICK $label · ${pick.position} OF ${detail.totalPicks}",
        Modifier.dmStamp().color(DmColor.textMuted).displayBlock(),
      )
    }
    key(pick.position) {
      Input(
        label = "Pick value",
        placeholder = if (detail.pool?.sport == Sport.OTHER) {
          "Enter a pick"
        } else {
          "e.g. Bijan Robinson, RB, ATL"
        },
        icon = "user",
        value = state.editValue,
        onValueChange = { state.editValue = it; state.editError = null },
        onEnter = { if (!unchanged && state.editValue.isNotBlank() && !state.editing) onSave() },
      )
    }
    state.editError?.let { message ->
      Toast(
        title = "Couldn't edit pick",
        message = message,
        tone = ToastTone.Rust,
        modifier = Modifier.styleModifier {
          property("max-width", "100%")
          property("box-sizing", "border-box")
        },
      )
    }
    Div(attrs = Modifier.displayFlex().gap(10.px).toAttrs()) {
      Button(
        "Cancel", variant = ButtonVariant.Ghost, disabled = state.editing,
        onClick = onDismiss, modifier = Modifier.flex(1),
      )
      Button(
        "Edit Pick", variant = ButtonVariant.Primary, icon = "check", loading = state.editing,
        disabled = state.editValue.isBlank() || unchanged, onClick = onSave, modifier = Modifier.flex(1),
      )
    }
  }
}

/**
 * The board's manage-pick sheet: set the value, retire the pick, or trade it to another team, in
 * one place. Trades reach every owner by email and push and can move who is on the clock, so
 * nothing is sent until the manager reviews the change set on the sheet's second step.
 */
@Composable
private fun ManagePickModal(
  detail: DraftDetailResponse,
  pick: PickDetail,
  state: RoomState,
  onDismiss: () -> Unit,
  onApply: () -> Unit,
) {
  val label = pickLabels(detail.picks)[pick.position] ?: pick.position.toString()
  val complete = detail.draft.status == DraftStatus.COMPLETE
  val cancelled = detail.draft.status == DraftStatus.CANCELLED
  val changes = pendingPickChanges(pick, state)
  PanelDialog(labelledBy = "manage-pick-title", onDismiss = onDismiss) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px).toAttrs()) {
      Icon("gear-six", IconWeight.Fill, Modifier.fontSize(26.px).color(DmColor.brass400))
      Div(attrs = Modifier.toAttrs { id("manage-pick-title") }) {
        SpanText("Manage pick", Modifier.roleH2().displayBlock())
        SpanText(
          "Manager override",
          Modifier.dmStamp().color(DmColor.brass400).displayBlock().margin(top = 2.px),
        )
      }
    }
    Div(attrs = Modifier.dmPanel().padding(12.px).displayFlex().flexDirection(FlexDirection.Column).gap(5.px).toAttrs()) {
      SpanText("${pick.teamName} · ${pick.ownerName}", Modifier.roleH3().displayBlock())
      SpanText(
        "ROUND ${pick.round} · PICK $label · ${pick.position} OF ${detail.totalPicks}",
        Modifier.dmStamp().color(DmColor.textMuted).displayBlock(),
      )
    }

    if (state.manageConfirming) {
      ManagePickSummary(pick, detail, changes)
    } else {
      key(pick.position) {
        Input(
          label = if (pick.filled) "Correct this pick" else "Pick for ${pick.teamName}",
          placeholder = if (detail.pool?.sport == Sport.OTHER) "Enter a pick" else "e.g. Bijan Robinson, RB, ATL",
          icon = "user",
          value = state.manageValue,
          onValueChange = { state.manageValue = it; state.manageError = null },
        )
      }
      if (state.manageSkipped) {
        SpanText(
          "A skipped pick never comes to the clock, so it holds no value.",
          Modifier.roleBody().fontSize(12.px).color(DmColor.textMuted).displayBlock(),
        )
      }
      Switch(
        label = "Skip this pick",
        checked = state.manageSkipped,
        disabled = complete || cancelled || pick.filled,
        onChange = { state.manageSkipped = it; state.manageError = null },
      )
      if (complete || cancelled || pick.filled) {
        SpanText(
          if (complete) "The draft is complete — picks can no longer be skipped or restored."
          else if (cancelled) "The draft is cancelled — un-cancel it before skipping or restoring picks."
          else "Clear this pick before skipping it.",
          Modifier.roleBody().fontSize(12.px).color(DmColor.textMuted).displayBlock(),
        )
      }
      Select(
        label = "Reassign to",
        hint = "Recorded as a trade from ${pick.teamName}. Everyone in the draft is notified.",
        value = state.manageTeamId,
        onValueChange = { state.manageTeamId = it; state.manageError = null },
      ) {
        detail.teams.forEach { team ->
          Option(team.id, attrs = { if (team.id == state.manageTeamId) attr("selected", "selected") }) {
            Text("${team.teamName} · ${team.ownerName}")
          }
        }
      }
    }

    state.manageError?.let { message ->
      Toast(
        title = "Couldn't update the pick",
        message = message,
        tone = ToastTone.Rust,
        modifier = Modifier.styleModifier {
          property("max-width", "100%")
          property("box-sizing", "border-box")
        },
      )
    }
    Div(attrs = Modifier.displayFlex().gap(10.px).toAttrs()) {
      if (state.manageConfirming) {
        Button(
          "Back", variant = ButtonVariant.Ghost, disabled = state.manageSaving,
          onClick = { state.manageConfirming = false }, modifier = Modifier.flex(1),
        )
        Button(
          "Apply Changes", variant = ButtonVariant.Primary, icon = "check", loading = state.manageSaving,
          onClick = onApply, modifier = Modifier.flex(1),
        )
      } else {
        Button(
          "Cancel", variant = ButtonVariant.Ghost, onClick = onDismiss, modifier = Modifier.flex(1),
        )
        Button(
          "Review Changes", variant = ButtonVariant.Primary, icon = "arrow-right",
          disabled = !changes.any,
          onClick = { state.manageConfirming = true; state.manageError = null },
          modifier = Modifier.flex(1),
        )
      }
    }
  }
}

/** The sheet's second step: only what is about to change, and who hears about it. */
@Composable
private fun ManagePickSummary(pick: PickDetail, detail: DraftDetailResponse, changes: PickChanges) {
  val newTeam = changes.teamId?.let { id -> detail.teams.firstOrNull { it.id == id } }
  Div(
    attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px).padding(12.px)
      .borderRadius(DmEffects.radiusMd)
      .border(1.px, LineStyle.Solid, DmColor.rust500)
      .backgroundColor(Color.rgba(176, 74, 47, 0.10f)).toAttrs()
  ) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(8.px).toAttrs()) {
      Icon("warning", IconWeight.Fill, Modifier.fontSize(18.px).color(DmColor.rust300))
      SpanText("Confirm these changes", Modifier.dmStamp().color(DmColor.rust300).displayBlock())
    }
    newTeam?.let {
      ManagePickSummaryLine("Trade", "${pick.teamName} → ${it.teamName} · ${it.ownerName}")
    }
    changes.playerText?.let { ManagePickSummaryLine("Value", "\"$it\"") }
    when (changes.skipped) {
      true -> ManagePickSummaryLine("Skip", "This pick will never come to the clock.")
      false -> ManagePickSummaryLine("Restore", "This pick comes back into the order.")
      null -> Unit
    }
    if (newTeam != null) {
      SpanText(
        "Everyone in the draft gets an email and a push about the trade" +
          (if (detail.onClock?.position == pick.position) ", and ${firstName(newTeam.ownerName)} goes on the clock with a fresh timer." else "."),
        Modifier.roleBody().fontSize(12.px).color(DmColor.textSecondary).lineHeight(1.5).displayBlock(),
      )
    }
  }
}

@Composable
private fun ManagePickSummaryLine(stamp: String, text: String) {
  Div(attrs = Modifier.displayFlex().alignItems(AlignItems.FlexStart).gap(8.px).toAttrs()) {
    SpanText(
      stamp,
      Modifier.dmStamp().color(DmColor.textMuted).minWidth(58.px).displayBlock(),
    )
    SpanText(
      text,
      Modifier.roleBody().fontSize(12.px).color(DmColor.text).lineHeight(1.5).displayBlock(),
    )
  }
}

// ── Toast overlay ──

@Composable
private fun ToastLayer(state: RoomState) {
  Presence(state.toast) { t ->
    Div(
      attrs = Modifier.styleModifier {
        property("position", "fixed")
        property("left", "50%")
        property("bottom", "20px")
        property("transform", "translateX(-50%)")
        property("z-index", "50")
      }.toAttrs()
    ) {
      // A replacement message is a new slip, so it arrives rather than rewriting the old one.
      key(t) {
        Toast(
          title = t.title, message = t.message, tone = t.tone, onClose = { state.toast = null },
          modifier = Modifier.toastMotion(),
        )
      }
    }
  }
}

// ── Derivations & helpers ──

private fun firstName(ownerName: String): String = ownerName.trim().substringBefore(" ").ifBlank { ownerName }

private fun sinceStamp(onClock: OnClockInfo): String {
  val since = onClock.sinceIso?.let { formatStampDateTime(it) }?.takeIf { it.isNotEmpty() }
  val owner = onClock.ownerName.uppercase()
  return if (since != null) "$owner · SINCE $since" else owner
}

/** The 1o make-pick meta stamp, e.g. "ROUND 2 · PICK 2.08 · 16 OF 96 · SINCE JUL 7, 8:02 AM". */
private fun pickMetaStamp(detail: DraftDetailResponse, onClock: OnClockInfo): String {
  val label = pickLabels(detail.picks)[onClock.position] ?: onClock.position.toString()
  val base = "ROUND ${onClock.round} · PICK $label · ${onClock.position} OF ${detail.totalPicks}"
  val since = onClock.sinceIso?.let { formatStampDateTime(it) }?.takeIf { it.isNotEmpty() }
  return if (since != null) "$base · SINCE $since" else base
}

/**
 * Picks that still have to be made before the caller's next turn, or null if they have none left.
 * Skipped picks never come to the clock, so they count neither as the caller's next turn nor
 * toward the wait ahead of it.
 */
internal fun picksUntilYours(picks: List<PickDetail>, yourTeamIds: List<String>, fromPosition: Int): Int? {
  val yourNext = picks
    .filter { it.teamId in yourTeamIds && !it.resolved && it.position >= fromPosition }
    .minByOrNull { it.position } ?: return null
  return picks.count { !it.resolved && it.position >= fromPosition && it.position < yourNext.position }
}

/** Map each pick's overall position to a "round.pickInRound" label, e.g. `2.08`. */
internal fun pickLabels(picks: List<PickDetail>): Map<Int, String> {
  val out = HashMap<Int, String>()
  picks.groupBy { it.round }.forEach { (round, rows) ->
    rows.sortedBy { it.position }.forEachIndexed { idx, p ->
      out[p.position] = "$round.${(idx + 1).toString().padStart(2, '0')}"
    }
  }
  return out
}

/** Teams ordered by the round-1 pick sequence (columns of the board), stragglers appended. */
private fun orderedTeams(detail: DraftDetailResponse): List<TeamSummary> {
  val firstPos = HashMap<String, Int>()
  detail.picks.sortedBy { it.position }.forEach { p -> if (p.teamId !in firstPos) firstPos[p.teamId] = p.position }
  return detail.teams.sortedBy { firstPos[it.id] ?: Int.MAX_VALUE }
}

private fun firstPosOf(detail: DraftDetailResponse, teamId: String): Int? =
  detail.picks.filter { it.teamId == teamId }.minByOrNull { it.position }?.position

private fun orderWord(detail: DraftDetailResponse): String? =
  detail.draft.draftOrder?.name?.lowercase()?.replaceFirstChar { it.uppercase() }

private fun boardTitle(detail: DraftDetailResponse): String {
  val parts = mutableListOf(detail.leagueName ?: "The draft")
  orderWord(detail)?.let { parts.add(it) }
  parts.add("${detail.totalPicks} picks")
  return parts.joinToString(" · ")
}

private fun completedStamp(detail: DraftDetailResponse): String {
  val completed = detail.draft.completedAt?.let { formatStampDate(it) }?.takeIf { it.isNotEmpty() }
  val filled = detail.picks.filter { it.filled && it.pickedAt != null }.mapNotNull { it.pickedAt }
  val start = filled.minOrNull() ?: detail.draft.startedAt
  val end = filled.maxOrNull() ?: detail.draft.completedAt
  val duration = if (start != null && end != null) {
    val days = daysBetween(start, end)
    if (days < 1) "UNDER A DAY FIRST PICK TO LAST" else "$days DAY${if (days == 1) "" else "S"} FIRST PICK TO LAST"
  } else null
  return listOfNotNull(completed?.let { "COMPLETED $it" }, duration).joinToString(" · ").ifBlank { "COMPLETE" }
}

private fun exportResultsCsv(detail: DraftDetailResponse) {
  val header = "Position,Round,Team,Owner,Pick"
  val rows = detail.picks.sortedBy { it.position }.map { p ->
    listOf(
      p.position.toString(), p.round.toString(), csvCell(p.teamName), csvCell(p.ownerName),
      csvCell(if (p.skipped) "Skipped" else p.playerText ?: ""),
    ).joinToString(",")
  }
  val content = (listOf(header) + rows).joinToString("\r\n")
  val base = (detail.leagueName ?: "draft").lowercase().replace(Regex("[^a-z0-9]+"), "-").trim('-').ifBlank { "draft" }
  downloadTextFile("$base-results.csv", content, "text/csv;charset=utf-8")
}

private fun csvCell(value: String): String {
  // CSV quoting does not prevent spreadsheet applications from evaluating formulas.
  val safeValue = if (value.firstOrNull() in setOf('=', '+', '-', '@')) "'$value" else value
  return "\"" + safeValue.replace("\"", "\"\"") + "\""
}

private fun downloadTextFile(filename: String, content: String, mime: String) {
  val blob = Blob(arrayOf<dynamic>(content), BlobPropertyBag(type = mime))
  val url = URL.createObjectURL(blob)
  val anchor = document.createElement("a") as HTMLAnchorElement
  anchor.href = url
  anchor.setAttribute("download", filename)
  document.body?.appendChild(anchor)
  anchor.click()
  document.body?.removeChild(anchor)
  URL.revokeObjectURL(url)
}
